import { isValidPassportNumber, isValidSAIDNumber } from '@ecdlink/core';
import { SA_CELL_REGEX } from '@ecdlink/ui';
import * as Yup from 'yup';

export interface CareGiverInformationFormModel {
  firstname: string;
  surname: string;
  relationId: string;
  careGiverIdField: string;
  careGiverPassportField: string;
  phoneNumber: string;
  preferId: boolean;
  finishRegistration?: boolean;
}

export const careGiverInformationFormSchema = Yup.object().shape({
  firstname: Yup.string().required('First name is required'),
  surname: Yup.string().required('Surname is required'),
  relationId: Yup.string().required(),
  phoneNumber: Yup.string()
    .required()
    .matches(SA_CELL_REGEX, 'Please enter a valid cell number'),
  careGiverIdField: Yup.string().when('preferId', {
    is: true,
    then: Yup.string()
      .required('ID number is required')
      .test(
        'is-valid-said',
        'Please enter a valid ID number',
        isValidSAIDNumber
      ),
  }),
  careGiverPassportField: Yup.string().when('preferId', {
    is: false,
    then: Yup.string()
      .required('Passport number is required')
      .test(
        'is-valid-passport',
        'Please enter a valid passport number, e.g. A1234567 or AB123456',
        isValidPassportNumber
      ),
  }),
});
